import BlockService from '@/services/BlockService'

const createBlocksModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    blocks: []
  },
  actions: {
    getBlocks: ({ commit, state }) => {
      BlockService.getBlocks(state.pageSize, state.page)
        .then((data) => {
          commit('SET_BLOCKS', { blocks: data.blocks })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getBlocks')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_BLOCKS: (state, { blocks }) => {
      state.blocks = blocks
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createBlocksModule
